export const text = {
  header: "Careers",
  description:
    "Trastar is a family owned business that has been operating in Texas for over 25 years. Check out our job postings on",
  linkedIn: "LinkedIn",
  exclamation: "!",
};
